//
// FileItem.js
// transport
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./MediaType";
import "@sas-dvr/ltjs-commons/models/particles/Link";

var FileItem = createModule("transport::FileItem", ["commons::PropertyOwner","commons::BaseModel","transport::TransportModel","transport::MediaType"], EventDispatcher, [
    ,
    {
        parentUri: 7,
        documentType: 7,
        modifiedDatetime: 9,
        encoding: 7,
        creationDatetime: 9,
        size: 4,
        createdBy: 7,
        contentDisposition: 7,
        name: 7,
        modifiedTimeStamp: 7,
        links: [1],
        modifiedBy: 7,
        creationTimeStamp: 7,
        id: 7,
        contentType: 7,
    },
    ,
    ,
    {
        createdUpdated: [0,1],
        modifiedUpdated: [0,1],
    },
    {
        _create: [4],
    },
    ,
]);
export default FileItem;
